export const toggleDropdown = (event: Event) => {
    const $el = event.target! as HTMLElement;
    if ($el.classList.contains("show")) {
        $el.classList.remove("show");
        $el.setAttribute("aria-expanded", "false");
    } else {
        $el.classList.add("show");
        $el.setAttribute("aria-expanded", "true");
    }
};
